"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Loader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Loader = require("./Loader.style");

var Loader = function Loader(_ref) {
  var color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement(_Loader.LoaderWrapper, {
    size: size
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 ".concat(size, " ").concat(size)
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: color,
    strokeWidth: "4",
    strokeMiterlimit: "10",
    d: "M27.2 45.1c-1 .2-2.1.2-3.2.2-11.8 0-21.3-9.5-21.3-21.3S12.2 2.7 24 2.7 45.3 12.2 45.3 24c0 .8 0 1.6-.1 2.4"
  })));
};

exports.Loader = Loader;
Loader.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.number
};
Loader.defaultProps = {
  color: 'white',
  size: 48
};
var _default = Loader;
exports.default = _default;